/**
 *@日语
 *@params
 *@author WangPing
 *@date 2020-07-20
 */

export default {
  _not_interested_in_this_video: 'このビデオに興味がありませんか？ %second%',
  _switch_one: '取替える',
  _next_reward_text: '取得する別のビデオを見る',
  _next_reward_button: '今見る',
  _just_for_you: 'Just for you', // 没有这个语言
  _recommend: 'Just for you',
}